<template>
  <PointTable v-if="route.query.modelId" />
  <PointTableList v-else/>
</template>
<script setup lang="ts">
import PointTableList from './PointTableList.vue'
import PointTable from './PointTable.vue'
import { useRoute } from 'vue-router'


const route = useRoute()

</script>
